<template>
  <div class="protocol-user-container">
    <h4 class="title">
      <md-icon name="arrow-left" size="lg" class="icon" @click="back"></md-icon>
      <span>用户协议</span>
    </h4>
    <div class="content">
      <p>为了保障您的合法权益，请您务必完整阅读并充分理解本授权书；若您不接受本授权书的任何条款，请您立即终止授权。</p>
      <p>本授权书一经出具即生效，本授权书是本人真实意思表示，本人同意承担由此带来的一切法律后果。</p>
      <p>本人拟向交子（中山）投资咨询有限公司（以下简称“贵司”）申请【 信用贷款 】业务（如融资租赁贷款、汽车消费融资、以租代购、消费分期、账户注册、游戏等），鉴于贵司在业务审查、审批或者业务达成的过程中需要收集及使用本人信息，<span class="important">本人已充分知悉并明确授权：</span></p>
      <h5>（一）为保证贵司正常提供前述业务及本人的正常使用，贵司有权采集并使用本人以下个人信息</h5>
      <p class="important">个人基本信息/身份信息：本人使用贵司的网站或客户端提供的业务的过程中，为完成账户注册、身份核验以及正常使用贵司提供的业务而提交的信息。例如姓名、电话号码、性别、身份证、驾驶证等；</p>
      <p class="important">设备信息：根据本人授予的具体权限，采集并记录本人所使用的设备相关信息。例如操作系统版本、设备内存信息、CPU信息、电池信息、IP地址等；</p>
      <p class="important">日志信息：本人使用贵司的网站或客户端提供的业务的过程中，产生的网络日志信息。例如本人的搜索查询内容、浏览器的类型、使用的语言、访问日期和时间及本人访问的网页记录等；</p>
      <p class="important">业务记录：因本人使用贵司业务产生的其他信息；</p>
      <h5>（二）鉴于贵司为本人提供前述业务中风险管控（如反欺诈和信贷审核）的必要，本人同意贵司有权视业务开展的实际情况，向合作的第三方风控服务商共享本授权书第（一）条中所述的本人个人信息，以完成前述必要的风险管控流程。</h5>
      <h5>（三）本人进一步同意，在协助贵司完成前述必要的风险管控流程时，第三方风控服务商有权在合理、必要范围内：</h5>
      <p>3.1 对贵司提供的本人个人信息进行保存、加工、处理、关联和使用；</p>
      <p>3.2 向合法存有本人个人信息的机构（含第三方风控服务商）查询、核验本人个人信息；</p>
      <p>3.3 通过SDK（software develop kit）等方式收集本人的设备信息，并对该等信息进行保存、加工、处理、关联和使用；</p>
      <p>3.4 对基于本授权书第3.1、3.2和3.3条收集、查询到的本人的个人信息进行分析和处理，出具相关报告并向贵司提供，法律法规、监管政策禁止的除外。</p>
      <h5>（四）本人进一步明确授权，为持续向本人提供前述业务及业务相关服务之目的，贵司与合作的第三方风控服务商有权保存、使用本人相关个人信息。</h5>
      <h5>本人在此声明：</h5>
      <p>本人已充分理解上述授权条款的含义，明确知晓并自愿承担因上述信息处理活动可能对本人的业务评估结果所产生的不利影响，充分了解该等信息处理活动依赖互联网开展而互联网环境并非绝对安全，本人仍同意上述授权。</p>
      <p>贵司已经对【 信用贷款 】业务的相关事宜与风险向本人进行充分披露及说明，本人已知晓并同意。</p>
      <p>本人承诺并保证，本人在本授权书项下所提供的所有信息真实、准确、完整、有效，且不会侵犯任何第三方的合法权利。</p>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    back() {
      this.$router.back()
    }
  }
}
</script>
<style scoped lang="stylus">
.protocol-user-container {
  background: #fff;
  padding: 0 20px 20px;
  min-height: 100vh;

  .content {
    padding-top: 100px;

    .important {
      font-weight: bold;
    }
  }

  .title {
    font-size: 40px;
    line-height: 80px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    background: #fff;
    border-bottom: 1px solid #eee;

    .icon {
      line-height: 80px;
      position: absolute;
      left: 20px;
    }
  }

  p {
    font-size: 30px;
    text-indent: 2em;
    line-height: 45px;

    &.tip {
      font-weight: bold;
    }
  }

  h5 {
    font-size: 30px;
    text-indent: 1.5em;
    margin-top: 10px;
  }
}
</style>
